module.exports = __webpack_public_path__ + "img/qrcode1.13b6ea12.jpg";